import * as React from 'react';
import * as main from '../../../styles/main.module.scss';
import * as reg from './style.module.scss';
import { Modal } from '../../../../../Modal';
import { RegFormWidget } from '../../../../../RegFormWidget';

export const RegPlatform = ({ id }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section className={reg.reg} id="user-action">
      <div className="container">
        <button className={main.mainBtn} onClick={() => {setShowModal(true)}}>
          Зарегистрироваться
        </button>
      </div>
      <Modal
        open={showModal}
        onClose={() => {setShowModal(false)}}
        PaperProps={{
          sx: {
            borderRadius: '4px'
          }
      }}>
        <RegFormWidget id={id}/>
      </Modal>
    </section>
  );
};
